/* Build-time environment check for Parcel */ const contactEndpoint = "https://contact-registration.flow-int.workers.dev";
// const contactEndpoint = "http://localhost:8787";
document.addEventListener('DOMContentLoaded', ()=>{
    const menuButton = document.querySelector('button.menu-button');
    const nav = document.querySelector('header nav');
    const header = document.querySelector('header');
    const modal = document.querySelector('.video-modal');
    const modalTriggers = document.querySelectorAll('.modal-video, .modal-agenda');
    const modalVideo = modal ? modal.querySelector('.video-modal__player') : null;
    const modalCloseElements = modal ? modal.querySelectorAll('[data-modal-close]') : [];
    const modalCloseButton = modal ? modal.querySelector('.video-modal__close') : null;
    const modalSections = modal ? Array.from(modal.querySelectorAll('[data-modal-section]')) : [];
    const modalForms = modal ? modal.querySelectorAll('.modal-form') : [];
    const CONTACT_HASH = '#contacto';
    const DEFAULT_STICKY_THRESHOLD = 100;
    const mobilePricing = document.querySelector('.mobile-pricing');
    let isNavOpen = !!(menuButton && menuButton.classList.contains('active'));
    let isModalOpen = false;
    let lastFocusedElement = null;
    let activeModalSection = null;
    let headerHeight = header ? header.offsetHeight : 0;
    let stickyScrollThreshold = DEFAULT_STICKY_THRESHOLD;
    const updateBodyScrollLock = ()=>{
        document.body.classList.toggle('lock-scroll', isNavOpen || isModalOpen);
    };
    const getScrollPosition = ()=>window.pageYOffset || document.documentElement.scrollTop || 0;
    const refreshStickyThreshold = ()=>{
        try {
            const rootStyles = getComputedStyle(document.documentElement);
            const cssValue = rootStyles.getPropertyValue('--sticky-header-threshold').trim();
            const parsedValue = Number.parseInt(cssValue, 10);
            stickyScrollThreshold = Number.isNaN(parsedValue) ? DEFAULT_STICKY_THRESHOLD : parsedValue;
        } catch (error) {
            stickyScrollThreshold = DEFAULT_STICKY_THRESHOLD;
        }
    };
    const updateHeaderMetrics = ()=>{
        if (!header) return;
        headerHeight = header.offsetHeight;
        if (header.classList.contains('is-sticky')) document.body.style.setProperty('--sticky-header-height', `${headerHeight}px`);
    };
    const setHeaderSticky = (shouldStick)=>{
        if (!header) return;
        const isCurrentlySticky = header.classList.contains('is-sticky');
        if (shouldStick === isCurrentlySticky) return;
        header.classList.toggle('is-sticky', shouldStick);
        document.body.classList.toggle('has-sticky-header', shouldStick);
        if (shouldStick) document.body.style.setProperty('--sticky-header-height', `${headerHeight}px`);
        else document.body.style.removeProperty('--sticky-header-height');
    };
    const setActiveModalSection = (sectionName)=>{
        if (!modal) return;
        activeModalSection = sectionName;
        modalSections.forEach((section)=>{
            const shouldShow = section.dataset.modalSection === sectionName;
            section.toggleAttribute('hidden', !shouldShow);
            section.classList.toggle('is-active', shouldShow);
            if (shouldShow) {
                const sectionTitle = section.querySelector('.video-modal__title');
                if (sectionTitle && sectionTitle.id) modal.setAttribute('aria-labelledby', sectionTitle.id);
            }
        });
        if (!sectionName) modal.removeAttribute('aria-labelledby');
    };
    if (mobilePricing) {
        // Create accordion behavior for the mobile pricing blocks
        const blocks = Array.from(mobilePricing.querySelectorAll('.pricing-block'));
        const blockData = blocks.map((block, index)=>{
            const headerEl = block.querySelector('.pricing-header');
            const contentEl = block.querySelector('.pricing-content');
            if (!headerEl || !contentEl) return null;
            if (!contentEl.id) contentEl.id = `mobile-pricing-content-${index + 1}`;
            headerEl.setAttribute('role', 'button');
            headerEl.setAttribute('tabindex', '0');
            headerEl.setAttribute('aria-controls', contentEl.id);
            headerEl.setAttribute('aria-expanded', 'false');
            contentEl.setAttribute('hidden', '');
            return {
                block,
                headerEl,
                contentEl
            };
        }).filter((item)=>item !== null);
        const closeAllBlocks = ()=>{
            blockData.forEach(({ block, headerEl, contentEl })=>{
                block.classList.remove('is-open');
                headerEl.setAttribute('aria-expanded', 'false');
                contentEl.setAttribute('hidden', '');
            });
        };
        const toggleBlock = (targetBlock)=>{
            const isCurrentlyOpen = targetBlock.block.classList.contains('is-open');
            closeAllBlocks();
            if (!isCurrentlyOpen) {
                targetBlock.block.classList.add('is-open');
                targetBlock.headerEl.setAttribute('aria-expanded', 'true');
                targetBlock.contentEl.removeAttribute('hidden');
            }
        };
        blockData.forEach((item)=>{
            const handleInteraction = (event)=>{
                event.preventDefault();
                toggleBlock(item);
            };
            item.headerEl.addEventListener('click', handleInteraction);
            item.headerEl.addEventListener('keydown', (event)=>{
                if (event.key === 'Enter' || event.key === ' ') handleInteraction(event);
            });
        });
    }
    if (menuButton && nav) {
        const openClass = 'is-open';
        if (!nav.id) nav.id = 'primary-navigation';
        menuButton.setAttribute('aria-controls', nav.id);
        menuButton.setAttribute('aria-expanded', 'false');
        nav.setAttribute('aria-hidden', 'true');
        const setNavigationState = (shouldOpen)=>{
            isNavOpen = shouldOpen;
            menuButton.classList.toggle('active', shouldOpen);
            nav.classList.toggle(openClass, shouldOpen);
            menuButton.setAttribute('aria-expanded', String(shouldOpen));
            nav.setAttribute('aria-hidden', String(!shouldOpen));
            updateBodyScrollLock();
        };
        menuButton.addEventListener('click', ()=>{
            const shouldOpen = !menuButton.classList.contains('active');
            setNavigationState(shouldOpen);
        });
        setNavigationState(isNavOpen);
    }
    if (modal) {
        const openModalSection = (sectionName, { focusClose = true } = {})=>{
            if (isModalOpen) return;
            isModalOpen = true;
            setActiveModalSection(sectionName);
            modal.classList.add('is-open');
            modal.removeAttribute('hidden');
            modal.setAttribute('aria-hidden', 'false');
            updateBodyScrollLock();
            if (sectionName === 'agenda' && window.location.hash !== CONTACT_HASH) history.replaceState(null, '', CONTACT_HASH);
            if (sectionName === 'video' && modalVideo) {
                modalVideo.currentTime = 0;
                const playPromise = modalVideo.play();
                if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(()=>undefined);
            }
            if (sectionName !== 'video' && modalVideo) {
                modalVideo.pause();
                modalVideo.currentTime = 0;
            }
            if (focusClose && modalCloseButton instanceof HTMLElement) modalCloseButton.focus({
                preventScroll: true
            });
        };
        const openModal = (event)=>{
            event.preventDefault();
            const trigger = event.currentTarget;
            if (!(trigger instanceof HTMLElement)) return;
            const sectionName = trigger.classList.contains('modal-agenda') ? 'agenda' : 'video';
            const activeElement = document.activeElement;
            if (activeElement instanceof HTMLElement) lastFocusedElement = activeElement;
            else lastFocusedElement = null;
            openModalSection(sectionName);
        };
        const closeModal = ()=>{
            if (!isModalOpen) return;
            isModalOpen = false;
            modal.classList.remove('is-open');
            modal.setAttribute('aria-hidden', 'true');
            modal.setAttribute('hidden', '');
            setActiveModalSection(null);
            updateBodyScrollLock();
            if (modalVideo) {
                modalVideo.pause();
                modalVideo.currentTime = 0;
            }
            if (lastFocusedElement instanceof HTMLElement) lastFocusedElement.focus({
                preventScroll: true
            });
            if (window.location.hash === CONTACT_HASH) history.replaceState(null, '', window.location.pathname + window.location.search);
            lastFocusedElement = null;
        };
        modalTriggers.forEach((trigger)=>{
            trigger.addEventListener('click', openModal);
        });
        modalCloseElements.forEach((closeEl)=>{
            closeEl.addEventListener('click', closeModal);
        });
        document.addEventListener('keydown', (event)=>{
            if (event.key === 'Escape') closeModal();
        });
        const openAgendaFromHash = ()=>{
            if (window.location.hash === CONTACT_HASH) {
                lastFocusedElement = null;
                openModalSection('agenda', {
                    focusClose: true
                });
            }
        };
        openAgendaFromHash();
        window.addEventListener('hashchange', ()=>{
            if (!modal) return;
            if (window.location.hash === CONTACT_HASH) {
                openAgendaFromHash();
                return;
            }
            if (isModalOpen) closeModal();
        });
        modalForms.forEach((form)=>{
            const submitButton = form.querySelector('.modal-form__submit');
            const originalButtonText = submitButton ? submitButton.textContent : '';
            const successSection = modal.querySelector('.video-modal__section--success');
            const setSubmittingState = (isSubmitting)=>{
                if (submitButton) {
                    submitButton.disabled = isSubmitting;
                    submitButton.textContent = isSubmitting ? "Enviando\u2026" : originalButtonText;
                }
            };
            const showSuccessSection = ()=>{
                setActiveModalSection('success');
                const closeLink = successSection ? successSection.querySelector('[data-modal-close]') : null;
                if (closeLink instanceof HTMLElement) closeLink.focus({
                    preventScroll: true
                });
            };
            form.addEventListener('submit', async (event)=>{
                event.preventDefault();
                if (!contactEndpoint) {
                    console.error("El endpoint de contacto no est\xe1 configurado. Defin\xed API_KEY en el entorno.");
                    alert("No se pudo enviar el formulario en este momento. Intent\xe1 m\xe1s tarde.");
                    return;
                }
                const formData = new FormData(form);
                const submittedData = Object.fromEntries(formData.entries());
                const fullName = (submittedData.fullName || '').toString().trim();
                const email = (submittedData.email || '').toString().trim();
                const phone = (submittedData.phone || '').toString().trim();
                const serviceInterest = submittedData.serviceInterest;
                if (!fullName || !email || !phone || !serviceInterest) {
                    alert("Complet\xe1 todos los campos para continuar.");
                    return;
                }
                setSubmittingState(true);
                try {
                    const recaptchaAction = 'CONTACT_FORM_SUBMISSION';
                    const recaptchaResponse = await grecaptcha.enterprise.execute('6Lcwqv8rAAAAAEjlrXqvuIJSSfCuDfBAXOdJV_y3', {
                        action: 'CONTACT_FORM_SUBMISSION'
                    });
                    const payload = {
                        fullName,
                        email,
                        phone,
                        serviceInterest,
                        recaptchaResponse,
                        recaptchaAction
                    };
                    const response = await fetch(contactEndpoint, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(payload)
                    });
                    if (!response.ok) {
                        const errorBody = await response.text();
                        throw new Error(`Request failed with status ${response.status}: ${errorBody}`);
                    }
                    const responseBody = await response.json().catch(()=>({}));
                    console.log('Modal form submission (success):', {
                        payload,
                        response: responseBody
                    });
                    console.log('Formulario enviado. Gracias por contactarte con Flowint.');
                    form.reset();
                    showSuccessSection();
                } catch (error) {
                    console.error('Modal form submission failed:', error);
                    console.log("No pudimos enviar el formulario. Revis\xe1 tus datos o intent\xe1 nuevamente m\xe1s tarde.");
                } finally{
                    setSubmittingState(false);
                }
            });
        });
    }
    if (header) {
        refreshStickyThreshold();
        updateHeaderMetrics();
        const evaluateHeaderSticky = ()=>{
            const currentScroll = getScrollPosition();
            setHeaderSticky(currentScroll >= stickyScrollThreshold);
        };
        evaluateHeaderSticky();
        window.addEventListener('scroll', ()=>{
            evaluateHeaderSticky();
        }, {
            passive: true
        });
        window.addEventListener('resize', ()=>{
            refreshStickyThreshold();
            updateHeaderMetrics();
            evaluateHeaderSticky();
        });
    }
    updateBodyScrollLock();
});
async function createAssessment({ // TODO: Replace the token and reCAPTCHA action variables before running the sample.
projectID = "flowint-website-3", recaptchaKey = "6Lcwqv8rAAAAAEjlrXqvuIJSSfCuDfBAXOdJV_y3", token = "action-token", recaptchaAction = "action-name" }) {
    // Create the reCAPTCHA client.
    // TODO: Cache the client generation code (recommended) or call client.close() before exiting the method.
    const client = new RecaptchaEnterpriseServiceClient();
    const projectPath = client.projectPath(projectID);
    // Build the assessment request.
    const request = {
        assessment: {
            event: {
                token: token,
                siteKey: recaptchaKey
            }
        },
        parent: projectPath
    };
    const [response] = await client.createAssessment(request);
    // Check if the token is valid.
    if (!response.tokenProperties.valid) {
        console.log(`The CreateAssessment call failed because the token was: ${response.tokenProperties.invalidReason}`);
        return null;
    }
    // Check if the expected action was executed.
    // The `action` property is set by user client in the grecaptcha.enterprise.execute() method.
    if (response.tokenProperties.action === recaptchaAction) {
        // Get the risk score and the reason(s).
        // For more information on interpreting the assessment, see:
        // https://cloud.google.com/recaptcha-enterprise/docs/interpret-assessment
        console.log(`The reCAPTCHA score is: ${response.riskAnalysis.score}`);
        response.riskAnalysis.reasons.forEach((reason)=>{
            console.log(reason);
        });
        return response.riskAnalysis.score;
    } else {
        console.log("The action attribute in your reCAPTCHA tag does not match the action you are expecting to score");
        return null;
    }
}

//# sourceMappingURL=repo.c2d94f96.js.map
